<script lang="ts">
    import {t} from "i18next";
    import {metaContext} from "../appStore";
</script>

<footer>
    <ul>
        <li><a href="/terms-of-service">{t("tos")}</a></li>
        <li><a href="/privacy">{t("privacy_policy")}</a></li>
        <li><a href="/changelog">{t("version", {version: $metaContext?.version})}</a></li>
    </ul>
</footer>

<style lang="scss">
  @use "src/scss/colors";

  footer {
    background-color: colors.$wine;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 8px;

    a {
      color: #fff !important;
      opacity: 0.7;
    }
  }

  ul {
    font-size: 12px;
    display: flex;
    gap: 24px;
    list-style: none;
  }
</style>